<template>
  <v-layout row class="pl-1 pt-1">
    <h4>{{$translate('UPLOAD_EVENT_PIC')}}</h4>
    <v-tooltip v-if="!hasImage || properties.deletable == false" bottom>
      <v-btn :disabled="this.properties.disable" slot="activator" class="v-btn-2-event-image-loader" round @click="pickFile">
        <v-icon>add_a_photo</v-icon>
      </v-btn>
      <span>{{imageTooltip}}</span>
    </v-tooltip>
    <v-flex v-for="(item, i) of properties.pictureUrl" :key="i">
      <!-- :class="[hasImage ? 'show_content' : 'not_show_content']"> -->
      <!-- <h4>{{item.pictureName}}</h4> -->
      <!-- <v-img :ref="'img_' + item.signalName" class="mb-2 mt-1" contain style="cursor:pointer;" :src="item.pictureUrl" height="50"/> -->
      <v-img class="mb-2 mt-1" contain style="cursor:pointer;" :src="item" height="50"/>
    </v-flex>
    <input
      type="file"
      style="display: none"
      :ref="imageInput"
      accept="image/*"
      cancelable="true"
      multiple="true"
      cancelBubble="true"
      @change="onImageFilePicked"
    >
  </v-layout>
</template>

<script>
import appConfig from "../../../config/app_config";

export default {
  name: "MultipleImageLoader",
  props: {
    properties: Object
  },
  watch: {
    // properties: {
    //   handler(data) {
    //     if (data.pictureUrl !== undefined && data.pictureUrl.length > 0) {
    //         let dataRecieved = data;
    //         dataRecieved.hasImage = true;
    //         this.extraPictures.push(dataRecieved);

    //     //   this.pictureName = this.properties.pictureName;
    //     //   this.image.src = this.properties.pictureUrl;
    //     //   this.hasImage = true;
    //     } else {
    //       this.hasImage = false;
    //       this.pictureName = "";
    //       this.image.src = "";
    //     }
    //   },
    //   deep: true
    // }
  },
  created() {
    // if (
    //   this.properties.pictureUrl !== undefined &&
    //   this.properties.pictureUrl !== ""
    // ) {
    //   this.pictureName = this.properties.pictureName;
    //   this.image.src = this.properties.pictureUrl;
    //   this.hasImage = true;
    // }
  },
  data() {
    return {
      extraPictures: [],
      hasImage: false,
      image: new Image(),
      imageTooltip: "upload an image",
      pictureName: "",
      imageInput: "imageInput_" + this.properties.signalName
    };
  },
  mounted() {},
  methods: {
    pickFile() {
      this.$refs[this.imageInput].click();
    },
    clearImage() {
      this.$emit(this.properties.signalName, {
        signalName: this.properties.signalName,
        file: "",
        url: ""
      });
    },
    onImageFilePicked(a) {
      console.log("Lorenzo a", a);
      // First clear the images
      this.clearImage();

      const maxSize = appConfig.maxSize.pictureSize;
      const files = a.target.files;

      if(files && files.length > 0) {
        Object.entries(files).forEach(([key, value]) => {
          console.log("Lorenzo value", value);
          let name = value.name;
          if(name.lastIndexOf(".") <= 0) {
            return;
          }

        const fr = new FileReader();

          fr.readAsDataURL(value);
          fr.onload = function() {
            console.log("Lorenzo fr.result", fr.result);
            if(fr.result === null) return;
          };

          fr.addEventListener("error", () => {
          });
          fr.addEventListener("load", () => {
            const o = {
              signalName: this.properties.signalName,
              file: value,
              url: fr.result,
            };
            this.$emit(this.properties.signalName, o);
          });
        });
      }

      console.log("multiPictureProperties: ", this.properties);


      // if (files[0] !== undefined) {
      //   if (files[0].size > maxSize) {
      //     window.EventBus.fire(
      //       "activateSnackBar",
      //       "File can't be bigger than 1MB"
      //     );
      //     return;
      //   }
      //   this.pictureName = files[0].name;
      //   if (this.pictureName.lastIndexOf(".") <= 0) {
      //     return;
      //   }

      //   const fr = new FileReader();
      //   fr.readAsDataURL(files[0]);
      //   fr.addEventListener("error", () => {
      //   });
      //   fr.addEventListener("load", () => {
      //     //clean first
      //     this.image.src = "";
      //     this.pictureName = "";
      //     this.hasImage = false;

      //     //reload the image
      //     this.image.src = fr.result;
      //     this.imageFile = files[0];
      //     this.hasImage = true;

      //     const o = {
      //       signalName: this.properties.signalName,
      //       file: this.imageFile,
      //       url: this.image.src
      //     };
      //     this.$emit(this.properties.signalName, o);
      //   });
      // } else {
      //   window.EventBus.fire("activateErrorDialog", "File is not available");
      //   this.image.src = "";
      //   this.imageFile = "";
      //   this.pictureName = "";
      //   this.hasImage = false;
      //   this.$emit(this.properties.signalName, {
      //     signalName: this.properties.signalName,
      //     file: "",
      //     url: ""
      //   });
      // }
    }
  }
};
</script>

<style scope>
.v-btn-2-event-image-loader {
  margin-left: -7em !important;
  margin-top: 3em !important;
  min-width: 1em;
}

.not_show_content {
  display: block;
}
.show_content {
  display: block;
}
#fileInput {
  display: none;
}
</style>
